import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { serviceGroups } from "@/mocks/services";

export default function ServicesOverview() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Hizmetlerimize genel bakış"
            title="Tek çatı altında dokuz dental görüntüleme yöntemi"
            description="2D panoramik ve sefalometrikten 3D dental tomografiye (CBCT) kadar tüm çekimleri düşük doz, dijital ve aynı gün raporlu olarak sunuyoruz."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {serviceGroups.map((group, groupIndex) => (
            <Reveal key={group.id} delay={groupIndex * 90}>
              <div className="flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-7 md:p-8">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <h3 className="font-heading text-xl font-medium tracking-tight text-foreground-950 md:text-2xl">
                    {group.label}
                  </h3>
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs font-semibold text-foreground-700">
                    <i className="ri-layout-grid-line text-sm text-primary-600" aria-hidden="true" />
                    {group.items.length} yöntem
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{group.caption}</p>

                <ul className="mt-6 flex flex-1 flex-col divide-y divide-background-200">
                  {group.items.map((item) => (
                    <li key={item.slug}>
                      <Link
                        to="/hizmetler"
                        className="group flex cursor-pointer items-center justify-between gap-3 py-3"
                      >
                        <span className="flex items-center gap-3">
                          <i className={`${item.icon} text-base text-primary-600`} aria-hidden="true" />
                          <span className="text-sm font-medium text-foreground-800">{item.title}</span>
                        </span>
                        <i
                          className="ri-arrow-right-line text-base text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600"
                          aria-hidden="true"
                        />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-10 flex justify-center">
            <Link
              to="/hizmetler"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              Tüm hizmetleri görüntüle
              <i className="ri-arrow-right-line text-base" aria-hidden="true" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}